import actionCreatorFactory from "typescript-fsa";
import { CommonAsyncType } from "../../core/types";
import { HotPropertyRequestBody, HotPropertyResponse } from "../../core/api/request/home/hot-property/types";
import { HomepageImageRequestBody, HomepageImageResponse } from "../../core/api/request/home/homepage-image/types";
import { InquiryFormRequestBody, InquiryFormResponse } from "../../core/api/request/home/inquiry-form/types";

const actionCreator = actionCreatorFactory("@@Home");

export const homeActions = {
    hotPropertyies: actionCreator.async<CommonAsyncType<HotPropertyResponse> & HotPropertyRequestBody, HotPropertyResponse>("HOT_PROPERTIES"),
    homepageImage: actionCreator.async<CommonAsyncType<HomepageImageResponse> & HomepageImageRequestBody, HomepageImageResponse>("HOMEPAGE_IMAGE"),
    inquiryForm: actionCreator.async<CommonAsyncType<InquiryFormResponse> & InquiryFormRequestBody, InquiryFormResponse>("INQUIRY_FORM"),
    resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
}